// extracted by mini-css-extract-plugin
export var container = "_g2-0";
export var infoIcon = "_g2-2";
export var titleRowCol = "_g2-1";